import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { MainStore } from 'src/app/common/main.store';
import { environment } from 'src/environments/environment';
import { TableColumn } from 'src/app/common/table/table-column.model';
import { tableResource } from 'src/app/common/table/table-resource';
import { CfgTableComponent } from 'src/app/common/table/table.component';
import { TableList } from '../db-template.model';

@Component({
  selector: 'app-db-template-list',
  templateUrl: './db-template-list.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [CfgTableComponent]
})
export class DbTemplateListComponent {

  private readonly store = inject(MainStore);
  private readonly router = inject(Router);

  readonly isAdminUser: boolean =
    this.store.currentUser.get().isAdmin && this.store.currentUser.get().departmentCode == '200';

  protected readonly dbTablesResource = tableResource<TableList, TableList[]>(
    () => (this.isAdminUser ? `${environment.adminConfig.apiUri}/dbtemplate/list` : undefined),
    {
      map: tables =>
        tables.map(table => ({
          ...table,
          displayObjectType:
            table.objectType === 0 ? 'Tabel'
            : table.objectType === 1 ? 'View'
            : table.objectType === 2 ? 'Stored Procedure'
            : 'Ukendt',
        })),
    },
  );

  protected readonly columns: TableColumn<TableList>[] = [
    { key: 'name', header: 'Navn', width: '400px' },
    { key: 'displayName', header: 'Vist navn' },
    { key: 'displayObjectType', header: 'Type', width: '180px' },
    { key: 'enabled', header: 'Aktiv', width: '100px', value: item => (item.enabled ? 'Ja' : 'Nej') },
  ];

  protected readonly defaultSort = { key: 'name', direction: 'asc' } as const;
  protected readonly trackById = (item: TableList) => item.id;
  protected readonly rowLink = (item: TableList) => ['/db-template', item.id];

  constructor() {
    if (!this.isAdminUser) {
      // No access to DB templates -> redirect to home
      this.router.navigate(['/home']);
    }
  }
}
